<template>
  <div class="card-content">
    <div>
      <div class="media">
        <div class="media-left">
          <font-awesome-icon :icon="['far', 'graduation-cap']" size="2x"></font-awesome-icon>
        </div>
        <div class="media-content">
          <div class="content">
            <p class="title is-6">Visit the <a href="https://academy.kymeta.io" target="_blank">Training Portal</a> to learn more about the u8 deployment and installation process.</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="configPermissions.configuratorVisible">
      <hr>
      <div class="media">
        <div class="media-left">
          <font-awesome-icon :icon="['far', 'cogs']" size="2x"></font-awesome-icon>
        </div>
        <div class="media-content">
          <div class="content">
            <p class="title is-6">See current Kymeta pricing in the <router-link to="/configurator">Kymeta Terminal Configurator.</router-link></p>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div>
      <div class="media">
        <div class="media-left kpt-media-icon" >
          <font-awesome-icon :icon="['far', 'user-headset']" size="2x"></font-awesome-icon>
        </div>
        <div class="media-content">
          <div class="content">
            <p class="title is-6" style="line-height: 1rem">Contact <a @click="$store.commit('setContextPane', 'support')">Kymeta Support</a> if you need assistance - we are here to help.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useUserStore } from '../../../user/user-store';

const userStore = useUserStore();
const configPermissions = computed(() => (userStore.state.user.account));
</script>
